import * as React from 'react';
const UnreadMessageChatIcon = () => (
  <svg width={8} height={8} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={8} height={8} rx={4} fill="#F98600" />
  </svg>
);
export default UnreadMessageChatIcon;
